import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// INTERFACES
import { ClientPaymentProfileApiService } from '../../../shared/services/api/client/client-payment-profile-api.service';
import { trackById } from '../../../shared/util/track-by.util';
import { ICreditCard } from '../../interfaces/client-payment-profile.interface';

// SERVICES

// UTILS

@Component({
  selector: 'lum-client-payment-profile-dropdown',
  templateUrl: './client-payment-profile-dropdown.component.html',
  styleUrls: ['./client-payment-profile-dropdown.component.scss'],
})
export class ClientPaymentProfileDropdownComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input()
  selectedPaymentId :number;

  @Input()
  businessAccountId :number;

  @Output()
  setPaymentProfileEvent = new EventEmitter<number>();

  cardControl :UntypedFormControl = new UntypedFormControl(null);

  creditCards :ICreditCard[] = [];
  params :{
    [param :string] :string | string[];
  } = {
    page: '1',
    limit: '1000',
  };

  trackById = trackById;

  private onDestroy$ = new Subject();

  constructor(
    private clientPaymentProfileApiService :ClientPaymentProfileApiService,
  ) {}

  ngOnInit() :void {
    this.getClientCreditCards();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  ngOnChanges(changes :SimpleChanges) :void {
    if (changes['selectedPaymentId']) {
      const newPaymentId = changes['selectedPaymentId'].currentValue;
      this.cardControl.setValue(newPaymentId);
    }
  }

  onSelect(event :MatSelectChange) :void {
    this.setPaymentProfileEvent.emit(event.value);
  }

  private getClientCreditCards() :void {
    this.clientPaymentProfileApiService
      .get({
        ...this.params,
        businessAccountId: this.businessAccountId.toString(),
      })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (response :any) => {
          const { data } = response;
          this.creditCards = data;
        },
        error: (error) => {},
      });
  }
}
